/**
 * UserInfo component
 * Displays an avatar with the user name
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Text from "../Text"
import Icon from "../Icon"
import theme from "../../styles/theme-main"
import {
  Wrapper,
  MenuIcon,
  NarrowMenuItem,
  MenuWrapper,
} from "../../styles/Menu"
import { NavLink } from "react-router-dom"
import onClickOutside from "react-onclickoutside"
import { SizeContext } from "../../App"
import {
  getCurrentSize,
  getVantageApplication,
  isHiringManager,
  isCandidate,
} from "utils/utils"
import {
  isCandidXMode,
  isProfileMode,
  isInternalMode,
} from "utils/productUtils"

const UserName = styled(Text)`
  // NOTE: "static" is the defualt positioning for a HTML element, so it acts like a "normal" div.
  position: ${props => (props.displayStatic ? "static" : "absolute")};
  right: 80px;
  top: 0;
  color: white;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export class UserInfo extends React.Component {
  toggleMenu = () => {
    const { isUserMenuOpen, openUserMenu, closeUserMenu } = this.props

    if (isUserMenuOpen) {
      closeUserMenu()
    } else {
      openUserMenu()
    }
  }

  closeMenu = () => {
    const { closeAllMenus } = this.props

    closeAllMenus()
  }

  handleClickOutside() {
    const currentSize = getCurrentSize()
    const { closeAllMenus } = this.props

    if (currentSize === "lg" || currentSize === "xl") {
      closeAllMenus()
    }
  }

  render() {
    const {
      user,
      logout,
      isUserMenuOpen,
      role,
      bgcolor = theme.colors.profileHeader,
      displayStatic = false,
    } = this.props

    let logoutLink
    if (isInternalMode()) {
      logoutLink = `https://www.rarerecruitment.co.uk`
    }
    const vantageApp = user && getVantageApplication(user)
    const showVantage = isCandidXMode()
      ? vantageApp && vantageApp.status === "ACTIVE"
      : isCandidate(user) && isProfileMode()
    const iconColor =
      bgcolor === "#ffffff"
        ? theme.colors.textSecondaryDark
        : theme.colors.light

    return (
      <React.Fragment>
        <SizeContext.Consumer>
          {size => (
            <React.Fragment>
              {size === "md" || size === "sm" || size === "xs" ? null : (
                <UserName displayStatic={displayStatic}>
                  {user.firstName}&nbsp;{user.lastName}
                </UserName>
              )}
            </React.Fragment>
          )}
        </SizeContext.Consumer>

        <Wrapper variant={"right"} isOpen={isUserMenuOpen}>
          <MenuIcon
            tabIndex={0}
            onClick={this.toggleMenu}
            onKeyPress={this.toggleMenu}
            isOpen={isUserMenuOpen}
            id="openMenu"
            color={iconColor}
          >
            <Icon variant={isUserMenuOpen ? "cross_sml" : "avatar"} />
          </MenuIcon>
        </Wrapper>

        <MenuWrapper isOpen={isUserMenuOpen} variant={"right"}>
          {showVantage && (
            <NarrowMenuItem onClick={this.closeMenu}>
              <NavLink
                id="profileLink"
                to={`/profile/create/${role && role.id ? role.id : "?step=0"}`}
                activeStyle={{
                  color: theme.colors.primaryDark,
                  fontWeight: "bold",
                }}
              >
                YOUR PROFILE
              </NavLink>
            </NarrowMenuItem>
          )}

          {(isHiringManager(user) || isProfileMode()) && (
            <NarrowMenuItem onClick={this.closeMenu}>
              <NavLink
                id="accountPreferencesMenu"
                to={"/account/details"}
                activeStyle={{
                  color: theme.colors.primaryDark,
                  fontWeight: "bold",
                }}
              >
                Account preferences
              </NavLink>
            </NarrowMenuItem>
          )}

          <NarrowMenuItem
            id="logoutLink"
            onClick={() => {
              logout(logoutLink)
              this.closeMenu()
            }}
          >
            <NavLink
              to={"#"}
              activeStyle={{
                color: theme.colors.primaryDark,
                fontWeight: "bold",
              }}
            >
              Log out
            </NavLink>
          </NarrowMenuItem>
        </MenuWrapper>
      </React.Fragment>
    )
  }
}

UserInfo.propTypes = {
  user: PropTypes.object,
}

export default onClickOutside(UserInfo)
